<template>
  <section class="page notification">
    <div class="header-wrap">
      <div class="menu-bar">
        <el-dropdown size="medium" @command="switchSourceType">
          <el-button class="menu-btn" type="text">
            {{ currentSourceTypeText
            }}<i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">全部消息</el-dropdown-item>
            <el-dropdown-item command="1">系统消息</el-dropdown-item>
            <el-dropdown-item command="2">机构消息</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="search-bar">
        <el-button class="all-readed-btn" @click="setAllReaded">
          全部标为已读
        </el-button>
        <div class="custom-search">
          <input
            type="text"
            class="custom-input"
            placeholder="请输入"
            v-model.trim="searchParams.messageTitle"
            @keyup.enter="handleSearch(searchParams.messageTitle)"
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            class="custom-button"
            @click="handleSearch(searchParams.messageTitle)"
            >搜索
          </el-button>
        </div>
      </div>
    </div>
    <div class="list-wrap">
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="notice-wrap"
        @click="dialogs(item)"
      >
        <div class="title" :class="[item.status === '0' ? 'unread' : '']">
          {{ item.messageTitle }}
        </div>
        <div class="content">{{ delHtmlTag(item.messageContent) }}</div>
        <div class="cell-row">
          <div class="source">{{ (item.cpName || "系统") | sourceText }}</div>
          <div class="time">{{ item.createTime | datetimeText }}</div>
        </div>
      </div>
      <div v-if="isEmpty">
        <no-data />
      </div>
    </div>
    <div v-if="!isEmpty" class="pagination-box">
      <el-pagination
        class="ou-pagination"
        background
        hide-on-single-page
        @size-change="changePageSize"
        @current-change="changePageCurrent"
        :current-page="searchParams.pageNum"
        :page-sizes="[10, 15, 20, 25, 30]"
        :page-size="searchParams.pageSize"
        layout="total, prev, pager, next, sizes, jumper, slot"
        :total="total"
      >
        <el-button @click="getNotificationList" class="ou-page-go"
          >GO</el-button
        >
      </el-pagination>
    </div>
    <el-dialog
      title="消息详情"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <div class="list-wrap listHeight">
        <div class="notice-wrap">
          <div
            class="title"
            :class="[dialogList.status === '0' ? 'unread' : '']"
          >
            {{ dialogList.messageTitle }}
          </div>
          <div
            class="content ql-editor ql-snow"
            v-html="dialogList.messageContent"
          ></div>
          <div class="cell-row">
            <div class="source">
              {{ (dialogList.cpName || "系统") | sourceText }}
            </div>
            <div class="time">{{ dialogList.createTime | datetimeText }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import "quill/dist/quill.core.css"; // 引入样式
import "quill/dist/quill.snow.css"; // snow theme
import "quill/dist/quill.bubble.css"; // bubble theme
import { mapGetters } from "vuex";
import {
  apiGetNotificationList,
  apiSetAllReaded,
  apiselectInfo,
} from "@/api/user/profile";
import NoData from "@/components/noData.vue";
export default {
  name: "notification",
  components: { NoData },
  data() {
    return {
      dataList: [],
      searchParams: {
        pageNum: 1,
        pageSize: 10,
        messageTitle: "",
        isSystem: "0",
      },
      dialogVisible: false,
      dialogList: "",
      total: 0,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["userId"]),
    currentSourceTypeText() {
      let dict = {
        0: "全部消息",
        1: "系统消息",
        2: "机构消息",
      };
      return dict[this.searchParams.isSystem];
    },
    isEmpty() {
      return !this.dataList.length;
    },
  },
  filters: {
    sourceText(value) {
      return value ? "来源：" + value : "";
    },
    datetimeText(value) {
      if (!value) {
        return "";
      }
      let date = value.split("T")[0] || "";
      let rest = value.split("T")[1] || "";
      return date + " " + rest.substr(0, 8);
    },
  },
  activated() {
    this.getNotificationList();
  },
  mounted() {},
  methods: {
    //已读
    selectInfo(id) {
      apiselectInfo({ messageId: id }).then((res) => {
        if (res.code == 200) {
          this.dialogVisible = true;
          this.getNotificationList();
        }
      });
    },
    //消息弹窗
    dialogs(item) {
      this.dialogList = item;
      this.selectInfo(item.messageId);
    },
    //关闭
    handleClose(done) {
      done();
    },
    delHtmlTag(str) {
      if (!str) {
        return "-";
      } else {
        str = str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, "<图片>");
        str = str.replace(/<[^>]+>/g, "");
        return str;
      }
    },
    getNotificationList() {
      let { pageNum, pageSize, messageTitle, isSystem } = this.searchParams;
      let params = { isSystem, pageSize, pageNum };
      params = messageTitle
        ? { ...params, messageTitle }
        : { ...params, messageTitle: "" };
      apiGetNotificationList(params).then((res) => {
        let list = res.rows || [];
        this.dataList = list;
        this.total = res.total || 0;
        // 此需求暂时废弃
        // let unreadList = []
        // list.map(item => {
        //   if(item.status==='0') {
        //     unreadList.push(item.messageId)
        //   }
        // })
        // if(!unreadList.length) {
        //   return
        // }
        // let ids = unreadList.join(',')
        // apiSetHasRead({ids}).then(res => {
        //   // 此处静默处理, 完成消息已读状态的设置但无需主动更新页面状态, 再次调用列表接口时更新即可
        // })
      });
    },
    setAllReaded() {
      apiSetAllReaded().then((res) => {
        // 主动全部标记为已读后刷新当前页
        this.getNotificationList();
      });
    },
    handleSearch() {
      this.getNotificationList();
    },
    switchSourceType(value) {
      this.searchParams.isSystem = value + "";
      this.getNotificationList();
    },
    changePageSize(val) {
      this.searchParams.pageSize = val;
      this.getNotificationList();
    },
    changePageCurrent(val) {
      this.searchParams.pageNum = val;
      this.getNotificationList();
    },
  },
};
</script>

<style scoped lang="scss">
.page.notification ::v-deep {
  background-color: #fffefd;
  padding: 30px 0 6px;
  .header-wrap {
    position: relative;
    display: flex;
    height: 32px;
    justify-content: space-between;
    .menu-bar {
      padding: 0 30px;
      .el-button {
        color: #666666;
        padding: 0;
      }
    }
    .all-readed-btn {
      width: 90px;
      height: 32px;
      background: #ffffff;
      border: 1px solid #f2f2f2;
      border-radius: 6px;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      padding: 2px;
      margin-right: 10px;
      &:hover {
        color: #2e9adb;
        border-color: #2e9adb;
      }
    }
    .search-bar {
      position: absolute;
      right: 30px;
      top: 0;
      height: 32px;
      display: flex;
      align-items: center;
      .custom-search {
        padding: 0;
        border: none;
        height: 100%;
        align-items: center;
        width: fit-content;
      }
    }
  }
  .list-wrap {
    .notice-wrap {
      padding: 20px 0 18px;
      border-bottom: 1px solid #f2f2f2;
      & > div {
        padding: 0 30px;
      }
      .title {
        font-size: 16px;
        color: #333333;
        font-weight: 400;
        cursor: pointer;
        &.unread {
          display: flex;
          align-items: center;
          &::before {
            content: "";
            display: inline-block;
            width: 5px;
            height: 5px;
            background-color: #ff5353;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
      .content {
        font-size: 14px;
        line-height: 1.2;
        color: #999999;
        font-weight: 400;
        margin-top: 20px;
        word-break: break-all;
      }
      .cell-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        margin-top: 18px;
      }
    }
  }
  .pagination-box {
    text-align: right;
    padding: 20px 30px;
  }
}
.listHeight {
  height: 66vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
